import "core-js/modules/es.array.push.js";
import getPx from '@/utils/getPx';
export default {
  data: function data() {
    return {
      isLoading: false,
      num: 180
    };
  },
  beforeCreate: function beforeCreate() {
    console.log('index.vue');
  },
  computed: {
    width: function width() {
      return getPx(this.num);
    },
    batteryNum: function batteryNum() {
      return parseInt(this.num / 248 * 100);
    }
  },
  beforeDestroy: function beforeDestroy() {},
  mounted: function mounted() {},
  methods: {
    onRefresh: function onRefresh() {
      var _this = this;
      setTimeout(function () {
        _this.$toast('刷新成功');
        _this.isLoading = false;
      }, 1000);
    },
    toVehicleManagement: function toVehicleManagement() {
      this.$router.push({
        path: '/vehicleManagement'
      });
    }
  }
};